const VISIBILITY_SYMBOLS = { public: '+', private: '-', protected: '#', internal: '~' };

/**
 * Maps a C# access modifier keyword to its UML visibility symbol.
 * @param {string} modifier - 'public' | 'private' | 'protected' | 'internal'
 * @returns {string} '+' | '-' | '#' | '~', defaults to '+'
 */
export function mapVisibility(modifier) {
  return VISIBILITY_SYMBOLS[modifier] || '+';
}
